import { ICopyable } from '../core/copyable.interface';
import { Sms } from './sms';

export class SmsTemplate implements ICopyable<SmsTemplate> {
    id: number;
    name: string;
    template: Sms;

    createCopy(): SmsTemplate {
        const instance = new SmsTemplate();
        instance.id = this.id;
        instance.name = this.name;
        instance.template = Sms.from(this.template);

        return instance;
    }
    copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.template = Sms.from(other.template);
    }

    public static from(other: any) {
        if (!!other) {
            const instance = new SmsTemplate();

            instance.id = other.id;
            instance.name = other.name;
            instance.template = Sms.from(other.template);

            return instance;
        } else {
            return null;
        }
    }
}
